import { render, staticRenderFns } from "./mdInHistList.vue?vue&type=template&id=60b0908d&scoped=true"
import script from "./mdInHistList.vue?vue&type=script&lang=js"
export * from "./mdInHistList.vue?vue&type=script&lang=js"
import style0 from "./mdInHistList.vue?vue&type=style&index=0&id=60b0908d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b0908d",
  null
  
)

export default component.exports